import graphConfig from './graphConfig.js';
import AuthService from "./auth.service.js";
import axios from "axios";

export default class GraphService {

  async getPhoto() {
    var authService = new AuthService();
    var accessToken;
    await authService.getToken().then((token) => {
      accessToken = token.accessToken;
    });

    let resp = await axios(graphConfig.graphPhotoEndpoint, {
      headers: {
        authorization: "bearer " + accessToken,
      },
      responseType: 'blob'
    });


    if (resp) {
      let bl = await resp.data;
      return URL.createObjectURL(bl);
    }
    return null;

  };

  async getPhotoByUserID(userID) {
    var authService = new AuthService();
    var accessToken;
    await authService.getToken().then((token) => {
      accessToken = token.accessToken;
    });

    let resp = await axios(graphConfig.grpahUserPhoto+userID+"/photo/$value", {
      headers: {
        authorization: "bearer " + accessToken,
      },
      responseType: 'blob'
    });


    if (resp) {
      let res = await resp.data;
      return URL.createObjectURL(res);
    }
    return null;

  }; 

  async getPhotoSmall() {
    var authService = new AuthService();
    var accessToken;
    await authService.getToken().then((token) => {
      accessToken = token.accessToken;
    });

    let resp = await axios(graphConfig.graphPhotoEndpoint48x48, {
      headers: {
        authorization: "bearer " + accessToken,
      },
      responseType: 'blob'
    });


    if (resp) {
      let bl = await resp.data;
      return URL.createObjectURL(bl);
    }
    return null;

  };


  async GetUserInformation() {
    var authService = new AuthService();
    var accessToken;
    await authService.getToken().then((token) => {
      accessToken = token.accessToken;
    });

    let resp = await axios(graphConfig.graphMeEndpoint, {
      headers: {
        authorization: "bearer " + accessToken,
      },
    });

    if (resp) {
      let info = await resp.data;
      return info;
    }
    return null;

  };

  async getMemberList()
  {
    var Members=[];
    await this.getContactList(graphConfig.graphMembersEndPoint).then((response)=>{
      Members = [...Members, ...response.data.value];
      if (response.data["@odata.nextLink"]) {
        this.getContactList(response.data["@odata.nextLink"]);
      } else {
        this.filterContacts(Members).then((res) => {
         return res;
        });
      }
    });

  };
  async filterContacts(Members) {
    return await Members.filter((x) => !!x.userPrincipalName);
  };
  async getContactList(url) {
    var authService = new AuthService();
    var accessToken;
    await authService.getToken().then((token) => {
      accessToken = token.accessToken;
    });

    let resp = await axios(url, {
      headers: {
        authorization: "bearer " + accessToken,
      },
    });

    if (resp) {
      let info = await resp;
      return info;
    }
    return null;
    
  };

}
